module.exports = __webpack_public_path__ + "static/media/waiting.d9c856ff.svg";